( function( $ ) {
    /*
     * Update the login box in the top right corner using AJAX
     */
    function updateHeaderLogin() {
        if( $( '.header-login-container' ).length < 1 ) {
            return;
        }

        $.ajax( {
            url      : themevars.ajaxurl,
            data     : {
                action  : 'pm_get_header_login_data',
                post_id : themevars.post_id
            },
            type     : 'POST',
            dataType : 'json'
        } ).done( function ( result ) {
            if (true !== result.success || undefined === result.data.headerlogin) {
                return;
            }

            if (result.data.logged_in === true) {
                $( '.header-login-container' ).replaceWith( result.data.headerlogin );
            }
        } );
    }

    updateHeaderLogin();

} )( jQuery );
